/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { registerLanguage } from '../_.contribution.js';
registerLanguage({
  id: 'typescript',
  extensions: ['.ts', '.tsx'],
  aliases: ['TypeScript', 'ts', 'typescript'],
  mimetypes: ['text/typescript'],
  loader: function () {
    return import('./typescript.js');
  }
});